import { EcommerceAPI } from "../Client";

const getCustomizationChildPayload = (payload = {}) => {
  if (payload?.dto) return payload.dto;

  const { customizationId, ...childPayload } = payload;
  return childPayload;
};

export const getCustomizationChildrenApi = async (payload = {}) => {
  try {
    const customizationId = payload?.customizationId ?? payload;
    const response = await EcommerceAPI.get(
      `/customization/children?customizationId=${encodeURIComponent(
        customizationId || "",
      )}`,
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const postCustomizationChildrenApi = async (payload = {}) => {
  try {
    const response = await EcommerceAPI.post(
      `/customization/children?customizationId=${encodeURIComponent(
        payload?.customizationId || "",
      )}`,
      getCustomizationChildPayload(payload),
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const updateCustomizationChildrenApi = async (payload = {}) => {
  try {
    const response = await EcommerceAPI.put(
      "/customization/children",
      getCustomizationChildPayload(payload),
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const deleteCustomizationChildrenApi = async (payload = {}) => {
  try {
    const id = payload?.id ?? payload;
    const response = await EcommerceAPI.delete(
      `/customization/children?id=${encodeURIComponent(id || "")}`,
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};
